// extracted by mini-css-extract-plugin
export var actions = "_mq-d";
export var benefitCard = "_mq-a";
export var benefitIcon = "_mq-b";
export var benefitLabel = "_mq-c";
export var benefits = "_mq-9";
export var bodyText = "_mq-8";
export var closeButton = "_mq-2";
export var content = "_mq-3";
export var eyebrow = "_mq-4";
export var heading = "_mq-5";
export var image = "_mq-f";
export var imagePanel = "_mq-e";
export var modal = "_mq-0";
export var shell = "_mq-1";
export var title = "_mq-6";
export var titleOffer = "_mq-7";